import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux';
import {
    AppBar, Button,
    Card,
    CardContent,
    Toolbar,
    Typography
} from '@material-ui/core';
import {withRouter} from "react-router-dom";
import ReduxCallHelper from "../../../../../store/actionreducers/callHelper";
import Input from "@material-ui/core/Input";
import * as _ from 'lodash'
import moment from "moment";

//get from uecare-api/property.js
const role = {
    adminMedical: {id: 1, label: 'adminMedical', name: '管理職醫生', abbr: 'AM'},
    medical: {id: 6, label: 'medical', name: '急診醫師', abbr: 'MD'},
};

const BasicInfoTab = ({medical: _medical, setMedicalRole, updateMedical}) => {
    const [medical, setMedical] = useState({
        user: {
            birthday: '',
            cell_phone_no: '',
            email: '',
            role: {
                label: '',
            },
            sex: '',
        },
    })

    useEffect(() => {
        if (!_.isEqual(medical, _medical))
            setMedical(_medical)
    }, [_medical])

    const medicalRole = medical.user && medical.user.role

    return (
        <div>
            {
                role[medicalRole && medicalRole.label] &&
                <div style={{padding: 10}}>
                    <Button
                        variant="raised"
                        color="default"
                        style={{marginRight: 10}}
                        onClick={async () => {
                            try {
                                await setMedicalRole({medicalId: medical.id, role: role.medical});
                            } catch (e) {
                                console.warn('you got an error = ', e);
                            }
                        }}
                    >
                        指定為一般醫師
                    </Button>
                    <Button
                        variant="raised"
                        color="secondary"
                        onClick={async () => {
                            try {
                                await setMedicalRole({medicalId: medical.id, role: role.adminMedical});
                            } catch (e) {
                                console.warn('you got an error = ', e);
                            }
                        }}
                    >
                        指定為管理職醫師
                    </Button>
                </div>
            }

            <Card className="w-full mb-16">
                <AppBar position="static" elevation={0}>
                    <Toolbar className="pl-16 pr-8">
                        <Typography variant="subheading" color="inherit" className="flex-1">
                            個人資料
                        </Typography>
                    </Toolbar>
                </AppBar>

                <CardContent>
                    <div className="mb-24">
                        <Typography className="font-bold mb-4 text-15">角色</Typography>
                        {(medical.user.role && medical.user.role.name) || '未定義'}
                    </div>
                    {/*<div className="mb-24">
                        <Typography className="font-bold mb-4 text-15">索引</Typography>
                        {medical.user && medical.user.id}
                    </div>*/}
                    <div className="mb-24">
                        <Typography className="font-bold mb-4 text-15">信箱</Typography>
                        <Input
                            onChange={event => setMedical({
                                ...medical,
                                user: {
                                    ...medical.user,
                                    email: event.target.value,
                                },
                            })}
                            value={medical.user.email}
                            style={{width:"auto"}}
                        />
                    </div>
                    <div className="mb-24">
                        <Typography className="font-bold mb-4 text-15">性別</Typography>
                        {medical.user.sex}
                    </div>
                    <div className="mb-24">
                        <Typography className="font-bold mb-4 text-15">服務分數</Typography>
                        {`${medical.user.score} 星`}
                    </div>
                    <div className="mb-24">
                        <Typography className="font-bold mb-4 text-15">手機號碼</Typography>
                        {
                            medical.user.cell_phone_no
                            ||`${medical.user.phone_country_code} ${medical.user.phone_number}`
                        }
                        <Typography className="mt-4 text-15" style={{color: '#005AB5'}}>
                            {medical.user.sms_verified_at ?
                                `驗證日期: ${moment(medical.user.sms_verified_at).format('YYYY-MM-DD')}`
                                : '尚未驗證手機號碼'}
                        </Typography>
                    </div>
                    {/*<div className="mb-24">
                        <Typography className="font-bold mb-4 text-15">是否使用暱稱</Typography>
                        {(medical.user.is_use_nickname === 1) ? '是' : '否'}
                    </div>*/}
                </CardContent>
                <Button
                    variant="raised"
                    className="mb-24"
                    style={{marginLeft: 10}}
                    onClick={async () => {
                        try {
                            const {id, user} = medical
                            await updateMedical({medical: {id, user}})
                        } catch (e) {
                            console.warn('error while updating medical', e)
                        }
                    }}
                >
                    修改
                </Button>
            </Card>
        </div>
    );
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setMedicalRole: ReduxCallHelper.ActionCreator.setMedicalRole,
        updateMedical: ReduxCallHelper.ActionCreator.updateMedical,
        getMedical: ReduxCallHelper.ActionCreator.getMedical,
    }, dispatch);
}


function mapStateToProps({callHelper: {medical}}) {
    return {
        medical
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BasicInfoTab));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/medical/tabs/BasicInfoTab.js